import React from "react";
import classNames from "classnames";
import Accordion from "./Accordion";

import classes from "./Accordion.module.scss";

type HTMLDivType = React.HTMLAttributes<HTMLDivElement>;

export type AccordionItem = {
   title?: string;
   description?: string;
};

export interface AccordionListProps extends HTMLDivType {
   items?: AccordionItem[];
}

const AccordionList: React.FC<AccordionListProps> = ({
   items = [],
   className,
   ...props
}) => {
   const [expanded, setExpanded] = React.useState<number | null>(null);

   const handleChange =
      (index: number) =>
         (event: React.SyntheticEvent, newExpanded: boolean) => {
            setExpanded(newExpanded ? index : null);
         };

   return (
      <div className={classNames(classes.accordionList, className)} {...props}>
         {items.map(({ title, description }, i) => (
            <Accordion
               key={i}
               expanded={expanded === i}
               onChange={handleChange(i)}
               title={title}>
               {description}
            </Accordion>
         ))}
      </div>
   );
};

export default AccordionList;
